import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import OnboardingPlannerViewSectionHeader
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Components/OnboardingPlannerViewSectionHeader';
import { useOnboardingPlannerViewSectionContext } from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/ViewSectionContext';
import DetailListItem from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/DetailListItem';
import { useOnboardingPlannerViewContext } from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/ViewContext';
// import DonutChart from 'Components/ComponentLibrary/Components/Vizualizations/DonutChart';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    padding: theme.spacing(0, 3),
  },
  header: {
  },
  content: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(0, 2),
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  detailListContainer: {
    flexGrow: 1,
  },
  notes: {

  },
  listItem: {
    margin: theme.spacing(1, 0),
    maxWidth: '300px',
  },
  chartContainer: {
    marginLeft: theme.spacing(16),
    marginBottom: theme.spacing(4),
  },
});

function ViewSectionLayout({
  classes,
}) {
  const {
    resource,
  } = useMetaLayoutContext();

  const {
    onAddTask,
    onAddNote,
  } = useOnboardingPlannerViewSectionContext();

  const { openSurvey } = useOnboardingPlannerViewContext();

  const [sectionDataResource] = resource.attr('sectionData');

  return (
    <div className={classes.root}>
      <OnboardingPlannerViewSectionHeader
        className={classes.header}
        title={resource.attr('title')}
        onAddTask={onAddTask}
        onAddNote={onAddNote}
      />
      <Box className={classes.content}>
        <div className={classes.detailListContainer}>
          {sectionDataResource.attr('detailItems').resources().list().map((detailItemResource) => {
            return (
              <DetailListItem
                key={detailItemResource.id()}
                onClick={() => {
                  openSurvey(detailItemResource.link('next').url(), 'DetailList');
                }}
                className={classes.listItem}
                resource={detailItemResource}
                test={'survey-detail-list-item'}
              />
            );
          })}
        </div>
      </Box>
      <div className={classes.chartContainer}>
        {/* <DonutChart */}
        {/*  className={classes.chart} */}
        {/*  title={'Income'} */}
        {/*  subtitle={'$75,000'} */}
        {/*  color={'secondary'} */}
        {/* /> */}
      </div>
    </div>
  );
}

ViewSectionLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

ViewSectionLayout.defaultProps = {
};

export default withStyles(styles)(ViewSectionLayout);
